/* tslint:disable */
/* eslint-disable */
/**
 * Plateformes API
 * API for managing plateformes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MinimalPlateformeDto } from './MinimalPlateformeDto';
import {
    MinimalPlateformeDtoFromJSON,
    MinimalPlateformeDtoFromJSONTyped,
    MinimalPlateformeDtoToJSON,
    MinimalPlateformeDtoToJSONTyped,
} from './MinimalPlateformeDto';
import type { PlateformeThemeDto } from './PlateformeThemeDto';
import {
    PlateformeThemeDtoFromJSON,
    PlateformeThemeDtoFromJSONTyped,
    PlateformeThemeDtoToJSON,
    PlateformeThemeDtoToJSONTyped,
} from './PlateformeThemeDto';

/**
 * 
 * @export
 * @interface GetCurrentPlateformeResponse
 */
export interface GetCurrentPlateformeResponse {
    /**
     * 
     * @type {MinimalPlateformeDto}
     * @memberof GetCurrentPlateformeResponse
     */
    currentPlateforme: MinimalPlateformeDto;
    /**
     * 
     * @type {PlateformeThemeDto}
     * @memberof GetCurrentPlateformeResponse
     */
    theme: PlateformeThemeDto;
    /**
     * 
     * @type {Array<MinimalPlateformeDto>}
     * @memberof GetCurrentPlateformeResponse
     */
    plateformes: Array<MinimalPlateformeDto>;
}

/**
 * Check if a given object implements the GetCurrentPlateformeResponse interface.
 */
export function instanceOfGetCurrentPlateformeResponse(value: object): value is GetCurrentPlateformeResponse {
    if (!('currentPlateforme' in value) || value['currentPlateforme'] === undefined) return false;
    if (!('theme' in value) || value['theme'] === undefined) return false;
    if (!('plateformes' in value) || value['plateformes'] === undefined) return false;
    return true;
}

export function GetCurrentPlateformeResponseFromJSON(json: any): GetCurrentPlateformeResponse {
    return GetCurrentPlateformeResponseFromJSONTyped(json, false);
}

export function GetCurrentPlateformeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCurrentPlateformeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPlateforme': MinimalPlateformeDtoFromJSON(json['currentPlateforme']),
        'theme': PlateformeThemeDtoFromJSON(json['theme']),
        'plateformes': ((json['plateformes'] as Array<any>).map(MinimalPlateformeDtoFromJSON)),
    };
}

export function GetCurrentPlateformeResponseToJSON(json: any): GetCurrentPlateformeResponse {
    return GetCurrentPlateformeResponseToJSONTyped(json, false);
}

export function GetCurrentPlateformeResponseToJSONTyped(value?: GetCurrentPlateformeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPlateforme': MinimalPlateformeDtoToJSON(value['currentPlateforme']),
        'theme': PlateformeThemeDtoToJSON(value['theme']),
        'plateformes': ((value['plateformes'] as Array<any>).map(MinimalPlateformeDtoToJSON)),
    };
}

